export const plateNumberFormatStrategy = (value: string) => {
  return (
    value.match('^[0-9A-Z]{2}-[0-9A-Z]{2,4}$') !== null ||
    value.match('^[0-9A-Z]{3}-[0-9A-Z]{2,3}$') !== null ||
    value.match('^[0-9A-Z]{4}-[0-9A-Z]{2}$') !== null ||
    value.match('^[A-Z]{3}-[0-9]{4}$') !== null
  );
};
